/* eslint no-console: 0 */
import mori from 'mori';
import { saveAs } from 'file-saver';

// TODO:  Revisit this to start with a Blob first - we may be able to avoid
// using middleware to relay the dataURI back to the client

/**
 * Convert a data URI into a Blob
 * @param  {dsataURI} string    data URI which needs conversion
 * @return {Blob}
 */
function dataURItoBlob(dataURI) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  const byteString = atob(dataURI.split(',')[1]);

  // write the bytes of the string to an ArrayBuffer
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  // write the ArrayBuffer to a blob, and you're done
  const bb = new Blob([ab]);
  return bb;
}

export default function() {
  return {
    scope: false,
    controller: Controller,
  };
}

Controller.$inject = ['$scope', '$document', '$window'];

function Controller($scope, $document, $window) {
  $scope.saveImage = saveImage;

  const doc = $document[0];

  const tabs = {
    'table': function() {
      return;
    },
    'graph': function() {
      const image = doc.getElementsByTagName('nvd3')[0].firstElementChild;
      const legend = doc.getElementsByTagName('chart-legend')[0]
        .firstElementChild;
      _savePng('graph', image, legend);
    },
    'map': function() {
      const image = doc.getElementsByClassName('datamap')[0];
      _savePng('map', image);
    },
  };

  function saveImage() {
    tabs[this.$parent.dc.router.currentParams.activeTab]();
  }

  // Searches all the stylesheets for styles that are needed,
  // Also allows selector remapping
  function _getStyles(el, selectorRemap = null, supressWarnings = true) {
    let css = '';
    const sheets = doc.styleSheets;
    for (let i = 0; i < sheets.length; i++) {
      if (_isExternal(sheets[i].href)) {
        if (!supressWarnings) {
          console.warn(
            `Cannot include styles from other hosts: ${sheets[i].href}`
          );
        }
        continue;
      }
      const rules = sheets[i].cssRules;
      if (rules !== null) {
        for (let n = 0; n < rules.length; n++) {
          const rule = rules[n];
          if (typeof (rule.style) !== 'undefined') {
            let match = null;
            try {
              match = el.querySelector(rule.selectorText);
            } catch (err) {
              if (!supressWarnings) {
                console.warn(
                  `Invalid CSS selector "${rule.selectorText}": err`
                );
              }
            }
            if (match) {
              const selector = selectorRemap
                ? selectorRemap(rule.selectorText)
                : rule.selectorText;
              css += `${selector} {${rule.style.cssText}}`;
            } else if (rule.cssText.match(/^@font-face/)) {
              css += rule.cssText + '\n';
            }
          }
        }
      }
    }
    return css;
  }

  // Grabbing and assembling the header's text
  function _headerText() {
    const indicatorName = angular.element('.headline-wrapper h2')
      .html()
      .replace('&nbsp;', ' '); // Just in case :-|
    const state = $scope.$parent.dc.router.currentParams;
    const immutableDistributions =
      $scope.$parent.dc.sheet.immutableDistributions;
    const stateTimeframes = $scope.$parent.dc.sheet.timeframes;

    const selected = (state.selectedDistributions || '')
      .split('--')
      .map((x) =>
        mori.get(
          mori.first(
            mori.filter(
              (item) => x === mori.get(item, 'slug'),
              immutableDistributions
            )
          ), 'characteristic'
        )
      );

    const firstTimeframe = state.activeTab === 'map' ?
      state.currentTimeframe : state.startTimeframe;
    const timeframes = [stateTimeframes[firstTimeframe]];

    if (state.activeTab === 'graph') {
      timeframes.push(stateTimeframes[state.currentTimeframe]);
    }

    return [
      `${indicatorName}:`,
      `${(selected[0] || '').length ? `${selected.join(' & ')},` : ''}`,
      `${timeframes.join(' - ')}`,
    ].join(' ');
  }

  // Checks if URL is external
  function _isExternal(url) {
    return url &&
      url.lastIndexOf('http', 0) === 0 &&
      url.lastIndexOf($window.location.host) === -1;
  }

  // Turns SVG -> Canvas and generates a click to download
  function _savePng(type, svg, svg2) {
    _svgAsDataUri(type, svg, svg2, (url) => {
      saveAs(dataURItoBlob(url), `${type}.png`);
    });
  }

  function _svgAsDataUri(type, svg, svg2 = null, callBack) {
    const xmlns = 'http://www.w3.org/2000/xmlns/';

    const outer = doc.createElement('div');
    const childrenWrapper = doc.createElement('g');
    const clone = svg.cloneNode(true);
    const width = svg.getBoundingClientRect().width;
    const height = 50 + ((!svg2)
      ? svg.getBoundingClientRect().height
      : svg.getBoundingClientRect().height +
        svg2.getBoundingClientRect().height);

    // Wrap clone's children so we can bump them down for the header
    _wrapAllElements(childrenWrapper, clone.childNodes);
    childrenWrapper.setAttribute('transform', 'translate(0, 24)');

    // If there is another SVG then drop it below the parent;
    if (svg2) {
      const clone2 = doc.createElement('g');
      clone2.innerHTML = svg2.innerHTML;
      clone2.setAttribute(
        'transform',
        `translate(5, ${svg.getBoundingClientRect().height + 16})`
      );
      clone.appendChild(clone2);
    }

    // Drop in the header
    const header = _text(12);
    header.setAttribute('y', 20);

    angular.element(header)
      .text(_headerText());

    clone.insertBefore(header, clone.firstChild);

    // Drop in the footer
    const footer = _text(10);
    footer.setAttribute('y', height - 10);

    // @TODO find where indicatorType is stored and use it
    // const sourceType =
    //   $scope.$parent.dc.initData.config.indicatorType === 'usa' ?
    //   'State' :
    //   'Global';
    const sourceType = 'State';
    angular.element(footer)
      .text(`SOURCE: Kaiser Family Foundation's ${sourceType} Health Facts.`);

    clone.appendChild(footer);

    // Do MISC styling and attribute setting needed
    const bkgd = doc.createElement('rect');
    bkgd.setAttribute('height', '100%');
    bkgd.setAttribute('width', '100%');
    bkgd.setAttribute('fill', '#fff');

    clone.insertBefore(bkgd, clone.firstChild);

    clone.setAttribute('version', '1.1');
    clone.setAttributeNS(xmlns, 'xmlns', 'http://www.w3.org/2000/svg');
    clone.setAttributeNS(xmlns, 'xmlns:xlink', 'http://www.w3.org/1999/xlink');
    clone.setAttribute('width', width);
    clone.setAttribute('height', height);
    clone.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
    outer.appendChild(clone);

    const style = doc.createElement('style');
    let appliedStyles;

    if (type === 'graph') {
      appliedStyles = [
        '.legend-text {color: #000;} ',
        '.nv-point-paths path {',
        'stroke: #aaa; stroke-opacity: 0;',
        'fill: #eee; fill-opacity: 0;}',
      ].join('');
    } else if (type === 'map') {
      appliedStyles = [].join('');
    }

    const css = doc.createTextNode(_getStyles(svg) + appliedStyles);
    style.setAttribute('type', 'text/css');
    style.appendChild(css);
    const defs = doc.createElement('defs');
    defs.appendChild(style);
    clone.insertBefore(defs, clone.firstChild);

    const doctype = ['<?xml version="1.0" standalone="no"?>',
      '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN"',
      ' "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">',
    ].join('');
    const svgText = doctype + outer.innerHTML;
    // const svgBlob = new Blob([svgText],
    //   { type: 'image/svg+xml;charset=utf-8' }
    // );

    const xhr = new XMLHttpRequest();
    xhr.open('POST', 'https://kff-svg-png-api.herokuapp.com/api/convert', true);
    xhr.setRequestHeader('Content-Type', 'text/html');
    xhr.setRequestHeader('height', height);
    xhr.setRequestHeader('width', width);
    xhr.onload = function() {
      if (callBack) {
        callBack(this.responseText);
      }
    };
    xhr.send(svgText);
  }

  // Creates and sets default styles for basic <text>
  function _text(fontSize) {
    const text = doc.createElement('text');
    text.setAttribute('height', '12');
    text.setAttribute(
      'style',
      [
        `font-size: ${fontSize}px`,
        'font-family: Arial, Helvetica, sans-serif',
        'font-weight: bold',
        'fill: #000',
      ].join(';')
    );
    text.setAttribute('x', '5');
    return text;
  }
}

/**
 * Wraps a list of elmeents with another element
 * @param  {HTMLNode} wrapper   item that will become wrapper
 * @param  {Array} elms         Array if HTMLNodes that will be wrapped
 * @return {NULL}
 */
function _wrapAllElements(wrapper, elms) {
  const el = elms.length ? elms[0] : elms;

  // Cache curr Parent & first sibling
  const parent = el.parentNode;

  wrapper.appendChild(el);

  while (elms.length) {
    wrapper.appendChild(elms[0]);
  }

  parent.appendChild(wrapper);
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/directives/saveAsImage/saveAsImage.js
 **/